function spbc_action__backups__rollback(obj){
	if(!confirm('Are you sure want to rollback to this backup?'))
		return;
	var self = jQuery(obj);
	var data = {
		action: 'spbc_rollback',
		backup_id: self.parent().attr('uid'),
		cols: self.parent().attr('cols_amount'),
	};
	var params = {
		spinner: self.parent().siblings('.tbl-preloader--tiny'),
		callback: function(result, data, params, obj){
			if(result.success){
				if(result.color)    {obj.css({background: result.background, color: result.color});}
				if(result.html)     {obj.html(result.html); setTimeout(function(){obj.fadeOut(300);}, 1500);}
			}
		},
	};
		
	spbc_sendAJAXRequest(data, params, self.parents('tr'));
}

function spbc_action__backups__delete(obj){
	if(!confirm('Are you sure want to delete this backup?'))
		return;
	var self = jQuery(obj);
	var data = {
		action: 'spbc_backup__delete',
		backup_id: self.parent().attr('uid'),
		cols: self.parent().attr('cols_amount'),
	};
	var params = {
		spinner: self.parent().siblings('.tbl-preloader--tiny'),
		callback: function(result, data, params, obj){
			if(result.success){
				if(result.color)    {obj.css({background: result.background, color: result.color});}
				if(result.html)     {obj.html(result.html); setTimeout(function(){obj.fadeOut(300);}, 1500);}
			}
		},
	};
		
	spbc_sendAJAXRequest(data, params, self.parents('tr'));
}

jQuery(document).ready(function(){
	
	spbc_tbl__sort__listen();
	
	// Preparing accordion
	jQuery('#spbc_scan_accordion2').accordion({
		header: "h3",
		heightStyle: 'content',
		collapsible: true,
		active: false,
		beforeActivate: function(event, ui){
			// jQuery( "#spbc_scan_accordion" ).accordion( "option", "active", 2 );
		},
	});
		
});